import { withTranslation } from "next-i18next";
import Link from "../../core/Link";
import Image from "../../core/Image";

const LgdLinks = ({ t }) => (
  <div className="d-flex flex-column w-50 mb-sm-0">
    <div className="d-flex mb-md-0">
      <section className="d-flex flex-column w-75">
        <h3>{t("common:footer.services")}</h3>
        <Link
          href={t("common:footer.links.help_center.link")}
          className="link-dark footer-link"
          noUnderline
        >
          {t("common:footer.links.help_center.text")}
        </Link>
        <Link
          href={t("common:footer.links.contact_us.link")}
          className="link-dark footer-link"
          noUnderline
        >
          {t("common:footer.links.contact_us.text")}
        </Link>
      </section>

      <section className="d-flex flex-sm-column ms-3">
        <div className="mb-sm-4">
          <h3>{t("common:footer.network")}</h3>
          <div className="d-flex">
            <a
              href="https://www.facebook.com/legranddressing/"
              className="link-dark me-2"
              target="_blank"
              rel="noreferrer"
            >
              <div style={{ width: "13px" }}>
                <Image src="facebookFooter" alt="logo facebook" className="w-100" />
              </div>
            </a>

            <a
              href="https://www.instagram.com/legranddressing/"
              className="link-dark me-2"
              target="_blank"
              rel="noreferrer"
            >
              <div style={{ width: "1.5rem" }}>
                <Image src="instagram" alt="logo instagram" className="w-100" />
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default withTranslation("common")(LgdLinks);
